var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEuroFilled = function SvgEuroFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M6.624 9A7.5 7.5 0 0 1 13.5 4.5c1.851 0 3.544.67 4.853 1.781a1 1 0 1 0 1.294-1.524A9.504 9.504 0 0 0 4.483 9H3a1 1 0 0 0 0 2h1.052a9.6 9.6 0 0 0 0 2H3a1 1 0 1 0 0 2h1.483a9.504 9.504 0 0 0 15.164 4.243 1 1 0 1 0-1.294-1.524A7.47 7.47 0 0 1 13.5 19.5 7.5 7.5 0 0 1 6.624 15H13a1 1 0 1 0 0-2H6.066a7.6 7.6 0 0 1 0-2H13a1 1 0 1 0 0-2z"
  })));
};
export default SvgEuroFilled;